import{a as t}from"./chunk-RAAYCPUM.js";function s(...e){return t(n,e)}var n=(e,r,o)=>({...e,[r]:o});export{s as a};
